var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("PortfolioNavigation", {
        attrs: { workspaceId: _vm.workspaceId, projectId: _vm.tchProjectId },
      }),
      _vm._v(" "),
      _vm.rm
        ? _c(
            "div",
            {
              staticClass: "container-fluid",
              staticStyle: { "margin-top": "80px", "padding-top": "20px" },
            },
            [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-lg-6" }, [
                  _c("small", { staticClass: "text-muted" }, [
                    _vm._v(
                      _vm._s(_vm.rm.PortfolioName) +
                        " / " +
                        _vm._s(_vm.rm.ScenarioName)
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "h1",
                    {
                      staticStyle: {
                        "font-size": "2em",
                        "font-weight": "300",
                        color: "#33475b",
                        margin: "0",
                      },
                    },
                    [_vm._v("Plan: Schedule")]
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "col-lg-6 d-flex flex-column justify-content-end",
                  },
                  [
                    _c("PortfolioScenarioNavigation", {
                      attrs: {
                        portfolioId: _vm.rm.PortfolioId,
                        corporateScenarioUrl: _vm.rm.CorporateScenarioUrl,
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "mt-5",
                  staticStyle: { height: "calc(100vh - 300px)" },
                },
                [
                  _c(
                    "gantt",
                    {
                      attrs: {
                        "data-source": _vm.dataSource,
                        "tooltip-template": "xxx",
                        editable: false,
                        height: "100%",
                      },
                      on: { change: _vm.edit },
                    },
                    [
                      _c("gantt-view", {
                        attrs: { type: "year", selected: true },
                      }),
                      _vm._v(" "),
                      _c("gantt-column", {
                        attrs: {
                          field: "title",
                          title: "Name",
                          sortable: true,
                        },
                      }),
                      _vm._v(" "),
                      _c("gantt-column", {
                        attrs: {
                          field: "start",
                          title: "Start",
                          format: "{0:MM/yyyy}",
                          sortable: true,
                          width: 120,
                        },
                      }),
                      _vm._v(" "),
                      _c("gantt-column", {
                        attrs: {
                          field: "end",
                          title: "End",
                          format: "{0:MM/yyyy}",
                          sortable: true,
                          width: 120,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }